export default "__VITE_ASSET__brJLHEdL__"